module.exports = __webpack_public_path__ + "media/images/map-4d986fc182294126e0aeb47fbd8713d5.png";